import { Phone, Cake } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import { Customer } from 'api/user-domain/user-domain.types';
import { formatPhoneNumber } from 'react-phone-number-input';
import { formatMonthDay } from '../customer.utils';

const CustomerAdditionalInfo = ({
  customer,
}: {
  customer: Partial<Customer>;
}) => {
  const phoneNumber = customer.phoneNumber ?? customer.phone;

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {phoneNumber && (
        <Stack direction="row" spacing={0.5} alignItems="center">
          <Phone color="primary" sx={{ fontSize: 14 }} />
          <Typography variant="caption">
            {formatPhoneNumber(
              phoneNumber.startsWith('+') ? phoneNumber : `+1${phoneNumber}`,
            )}
          </Typography>
        </Stack>
      )}
      {customer.dateOfBirth && (
        <Stack direction="row" spacing={0.5} alignItems="center">
          <Cake
            color="primary"
            sx={{ fontSize: 14 }}
            data-testid="CakeIcon.Card"
          />
          <Typography variant="caption" data-testid="BirthdayText.Span">
            {formatMonthDay(customer.dateOfBirth)}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
};
export default CustomerAdditionalInfo;
